
import { motion } from "framer-motion";

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">About Aarsa</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p className="text-lg">
                Aarsa is a premium jewellery brand that celebrates timeless elegance and contemporary design.
                We are a product of Zestaura Pvt. Ltd., dedicated to bringing you exquisite handcrafted
                jewellery pieces that reflect your unique style and personality.
              </p>
              <p>
                Our journey began with a vision to blend traditional artistry with modern aesthetics,
                creating pieces that are perfect for every occasion - from bridal collections to everyday
                wear. Each piece in our collection is carefully crafted with attention to detail, using
                premium materials and techniques passed down through generations.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Our Mission</h2>
              <p>
                To make premium jewellery accessible to everyone, while maintaining the highest standards
                of quality and craftsmanship. We believe that every piece of jewellery should tell a story
                and make you feel extraordinary.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Our Values</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Quality: We use only the finest materials and craftsmanship</li>
                <li>Authenticity: Every piece is genuine and carefully curated</li>
                <li>Customer First: Your satisfaction is our </li>
                <li>Sustainability: We are committed to ethical and sustainable practices</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
